var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarTutorialsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50462 3.15779C1.50462 2.40789 2.11253 1.79999 2.86242 1.79999H13.1377C13.8875 1.79999 14.4955 2.40789 14.4955 3.15779V12.3046H15.3395C15.7043 12.3046 16 12.6004 16 12.9652C16 13.33 15.7043 13.6257 15.3395 13.6257H0.660551C0.295739 13.6257 0 13.33 0 12.9652C0 12.6004 0.295739 12.3046 0.660551 12.3046H1.50462V3.15779ZM2.75233 12.3046H13.2477V3.15779C13.2477 3.09698 13.1985 3.04769 13.1377 3.04769H2.86242C2.80162 3.04769 2.75233 3.09698 2.75233 3.15779V12.3046ZM6.80578 5.57463C6.97522 5.47607 7.18429 5.47505 7.35468 5.57195L10.2843 7.23801C10.4564 7.33586 10.5626 7.51856 10.5626 7.7165C10.5626 7.91444 10.4564 8.09714 10.2843 8.195L7.35468 9.86105C7.18429 9.95795 6.97522 9.95693 6.80578 9.85837C6.63634 9.75981 6.5321 9.57858 6.5321 9.38256V6.05045C6.5321 5.85443 6.63634 5.6732 6.80578 5.57463ZM7.63302 8.43627L8.89866 7.7165L7.63302 6.99674V8.43627Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarTutorialsInactive);
export default __webpack_public_path__ + "static/media/navbar-tutorials-inactive.55219611304be755298bc01052c26a27.svg";
export { ForwardRef as ReactComponent };